export declare interface APIAlias {
  AddressDomain: string;
  AddressId: string;
  AddressName: string;
  AddressType: string;
  AddressUsername: string;
  AliasDomain: string;
  AliasUsername: string;
  AppAddressType: string;
  Number: string;
  UserId: string;
}

export declare interface Alias {
  addressDomain: string;
  addressId: string;
  addressName: string;
  addressType: string;
  addressUsername: string;
  aliasDomain: string;
  aliasUsername: string;
  appAddressType: string;
  number: string;
  userId: string;
}

export function apiAliasToAlias(apiAlias: APIAlias): Alias {
  return {
    addressDomain: apiAlias.AddressDomain,
    addressId: apiAlias.AddressId,
    addressName: apiAlias.AddressName,
    addressType: apiAlias.AddressType,
    addressUsername: apiAlias.AddressUsername,
    aliasDomain: apiAlias.AliasDomain,
    aliasUsername: apiAlias.AliasUsername,
    appAddressType: apiAlias.AppAddressType,
    number: apiAlias.Number,
    userId: apiAlias.UserId
  };
}
